var common = require("../../utiles/common.js");

module.exports = {
  register: function () {
    document.createElement("sso");
    ko.components.register("sso", {
      viewModel: function (params) {
        var $this = this;
        // 手势是否设置
        $this.sPwdStatus = ko.observable(true);
        $this.spwd_msg = ko.observable();
        //-------------------------------------
        var entitlementId = sessionStorage.getItem("entitlementId");
        var authId = sessionStorage.getItem("authId");
        //var callBack = sessionStorage.getItem(entitlementId)?sessionStorage.getItem(entitlementId):"";
        var callBack = sessionStorage.getItem("callBack")
          ? sessionStorage.getItem("callBack")
          : "";
        // 获取是否要执行多因子认证
        var mfa = {};
        $this.isAuth = function (res) {
          var data = JSON.parse(res.responseText);
          if (
            data.message == "ERROR-14003:本次强认证已经过期，请刷新页面重试"
          ) {
            common.alert("本次强认证已经过期,回到登录?", function () {
              common.redirectTo("/#/");
            });
          }
        };
        try {
          if (entitlementId) {
            mfa = common.fetch(
              "/auth/mfa/listByEntitlement",
              {
                method: "POST",
                query: {
                  entitlementId: entitlementId,
                },
              },
              $this.isAuth
            ).data;
          }
          if (authId) {
            mfa = common.fetch(
              "/auth/mfa/listByAuthId",
              {
                method: "POST",
                query: {
                  authId: authId,
                },
              },
              $this.isAuth
            ).data;
          }
          $this.mfa = mfa;
        } catch (error) {
          $this.mfa = undefined;
        }
        console.log($this.mfa);
        //人脸识别
        var szTransNum = "1234567890";
        var szToken = "123456789012";
        var szParam = "";

        function LoadParam() {
          szParam =
            '<?xml version="1.0"?>\n<param>\n  <outtype>0</outtype>\n  <actionorder>***</actionorder>\n <actionlist>123456</actionlist>\n   <imgWidth>640</imgWidth>\n    <imgHeight>480</imgHeight>\n    <imgCompress>85</imgCompress>\n    <pupilDistMin>12</pupilDistMin>\n    <pupilDistMax>400</pupilDistMax>\n    <isActived>2</isActived>\n    <timeOut>30</timeOut>\n    <isAudio>1</isAudio>\n    <version>3.0.0.5</version>\n    <deviceIdx>0</deviceIdx>\n    <definitionAsk>12</definitionAsk>\n    <cryptType>0</cryptType>\n    <interfaceType>3</interfaceType>\n    <headLeft>12</headLeft>\n    <headRight>12</headRight>\n    <headLow>12</headLow>\n    <headHigh>12</headHigh>\n    <eyeDegree>12</eyeDegree>\n    <mouthDegree>12</mouthDegree>\n    <edage1>0.01</edage1>\n    <edage2>0.99</edage2>\n    <action>3</action>\n    <goodOne>0</goodOne></param>';
        }

        // 设置执行SSO的方法
        $this.executeSSO = function () {
          $this.loading = ko.observable(true);
          if ($this.authId) {
            common.redirectTo(
              "/auth/sso/runApp?entitlementId=" +
                entitlementId +
                "&authId=" +
                $this.authId +
                "&callBack=" +
                callBack
            );
          } else {
            common.redirectTo(
              "/auth/sso/runApp?entitlementId=" +
                entitlementId +
                "&callBack=" +
                callBack
            );
          }
        };

        //轮询查询是否验证成功
        $this.valid = function () {
          $this.validInterval = common.addInterval(function () {
            var isConfirmed = common.fetch(
              "/auth/mfa/validate",
              {
                query: { authId: $this.authId },
              },
              function (data) {
                var msg = JSON.parse(data.responseText).message;
                common.errorAlert(msg);
                clearInterval($this.validInterval);
              }
            ).data;
            //console.log(isConfirmed)
            if (isConfirmed.success && !isConfirmed.redirectUrl) {
              $this.executeSSO();
            }
            if (isConfirmed.success && isConfirmed.redirectUrl) {
              clearInterval($this.validInterval);
              common.redirectTo(isConfirmed.redirectUrl);
            }
          }, 3000);
        };

        //人脸识别
        $this.getFaceB64A = function () {
          console.log(TFace1);
          //console.log(szParam)
          if (TFace1) {
            var xml = TFace1.getFaceB64A(szParam, szToken, szTransNum);
            console.log(xml);
            var aPos = xml.indexOf("<imgBase>");
            var bPos = xml.indexOf("</imgBase>");
            var faceImg = xml.substr(aPos + 9, bPos - aPos - 10);
            console.log(faceImg);
            var param = { authId: $this.authId, faceImg: faceImg };
            if (faceImg) {
              common.fetch("/auth/mfa/face/compare", {
                method: "POST",
                data: JSON.stringify(param),
              });
              $this.valid();
            } else {
              setTimeout(function () {
                $this.getFaceB64A();
              }, 1000);
            }
          }
        };
        if (mfa.deny) {
          common.redirectTo(
            "/#/prevent?msg=" + mfa.message + "&entitlementId=" + entitlementId
          );
          return false;
        }
        // 判断是否要执行MFA
        if (mfa.skipMFA) {
          $this.executeSSO();
        } else {
          $this.loading = ko.observable(false);
          $this.authId = mfa.authId;
          $this.qrType = mfa.qrType;
          $this.topBG = ko.observable("");
          $this.options = ko.observableArray();
          $this.current = ko.observable("");

          $this.mfaList = mfa.mfaList ? mfa.mfaList : [];
          $this.isScanned = ko.observable(false);
          $this.errorMsg = ko.observable("");
          $this.codeBtnText = ko.observable(_i18n("发送验证码"));
          $this.codeBtnTime = ko.observable(60);
          $this.interval = null;
          $this.intervalCode = null;
          $this.sendTotp = function () {
            var postD = $("#dynamicCode input").serializeObject();
            common.fetch("/auth/mfa/totp/validate", {
              method: "POST",
              query: { authId: $this.authId, totpCode: postD.totpCode },
            });
          };
          //短信
          $this.goSms = function () {
            $this.codeBtnText(_i18n("发送验证码"));
            var smsResult = common.fetch("/auth/mfa/sms/send", {
              method: "POST",
              query: { authId: $this.authId },
            });
            console.log(smsResult);
            if (smsResult.data) {
              $this.intervalCode = common.addInterval(function () {
                if ($this.codeBtnTime() === 0) {
                  clearInterval($this.intervalCode);
                  $this.codeBtnText(_i18n("发送验证码"));
                  $this.codeBtnTime(60);
                } else {
                  $this.codeBtnTime($this.codeBtnTime() - 1);
                  $this.codeBtnText(
                    $this.codeBtnTime() + "s" + _i18n("重新发送")
                  );
                }
              }, 1000);
            }
          };
          $this.sendSms = function () {
            common.fetch("/auth/mfa/sms/verify", {
              method: "POST",
              query: {
                authId: $this.authId,
                verifyCode: $("#verifyCode").val(),
              },
            });
          };
          $this.setMFA = function (code) {
            console.log(code);
            $this.errorMsg("");
            if ($this.locked) {
              return;
            }
            if ($this.interval) {
              clearInterval($this.interval);
            }
            var bg = urlAddPrefix("/public/images/mfa/" + code + "_TOP.jpg");
            $this.topBG("url(" + bg + ")");
            $this.options.removeAll();
            for (var i in mfa.mfaList) {
              var optionCode = mfa.mfaList[i].code;
              var img = urlAddPrefix(
                "/public/images/mfa/" + optionCode + "_OPTION.jpg"
              );
              if (optionCode === code) {
                $this.sPwdStatus(mfa.mfaList[i].sPwdStatus ? true : false);
                img = urlAddPrefix(
                  "/public/images/mfa/" + optionCode + "_OPTION_ACTIVE.jpg"
                );
                // 手势判断提示
                if ($this.sPwdStatus()) {
                  $this.spwd_msg("");
                } else {
                  $this.spwd_msg("手势首次使用，需设置，重复两次");
                }
              }
              if (optionCode === code && mfa.mfaList[i].errorMsg !== "") {
                $this.errorMsg(code);
              }
              $this.options.push({
                img: img,
                code: optionCode,
              });
            }
            console.log($this.current());
            if (
              $this.current() === "FINGERPRINT" &&
              $this.errorMsg() === "FINGERPRINT"
            ) {
              common.fetch("/auth/mfa/fingerprint/cancel", {
                method: "POST",
                query: { authId: $this.authId },
              });
            }
            $this.current(code);
            if (code === "QR_CODE") {
              setQR();
              $this.interval = common.addInterval(function () {
                var isScanned = common.fetch(
                  "/auth/mfa/qrcode/isScanned",
                  {
                    query: { authId: $this.authId },
                  },
                  function (data) {
                    var msg = JSON.parse(data.responseText).message;
                    common.errorAlert(msg);
                    clearInterval($this.interval);
                  }
                ).data;
                if (isScanned === true) {
                  this.locked = true;
                  // 取消当前interval
                  clearInterval($this.interval);
                  $this.isScanned(true);
                  // 轮询是否手机上已经验证
                  $this.valid();
                }
              }, 3000);
            } else if (code === "FACERECOGNITION") {
              setTimeout(function () {
                $this.getFaceB64A();
              }, 1000);
            } else if (code === "SPWD") {
              setTimeout(function () {
                $this.initGesture();
              }, 100);
            } else {
              if (
                code === "FINGERPRINT" &&
                $this.errorMsg() !== "FINGERPRINT"
              ) {
                common.fetch("/auth/mfa/fingerprint/send", {
                  method: "POST",
                  query: { authId: $this.authId },
                });
              }
              if (code) {
                $this.valid();
              }
            }
          };

          $this.setMFA($this.mfaList[0] ? $this.mfaList[0].code : "");

          function setQR() {
            $("#qr").html("");
            new QRCode(document.getElementById("qr"), {
              text: JSON.stringify({
                authId: $this.authId,
                qrType: $this.qrType,
              }),
              width: 160,
              height: 160,
            });
          }

          // 手势验证

          $this.initGesture = function () {
            var initPwd = "";
            var pwdType = { decryptType: "SM2", cryptKey: "" };
            try {
              pwdType.cryptKey =
                "04" + common.fetch("/auth/flow/login/getSm2PubK").data;
            } catch (error) {}
            console.info("postD.password", pwdType);

            if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
              $("#gesturepwd").GesturePasswd({
                backgroundColor: "transparent", //背景色
                // color: "#bababa", //主要的控件颜色
                color: "#bababa", //主要的控件颜色
                roundRadii: 36, //大圆点的半径
                pointRadii: 12, //大圆点被选中时显示的圆心的半径
                space: 38, //大圆点之间的间隙
                width: 330, //整个组件的宽度
                height: 330, //整个组件的高度
                lineColor: "#006eff", //用户划出线条的颜色
                zindex: 100, //整个组件的css z-index属性
              });
            } else {
              $("#gesturepwd").GesturePasswd({
                backgroundColor: "transparent", //背景色
                color: "rgba(255,255,255,0.3)", //主要的控件颜色
                roundRadii: 18, //大圆点的半径
                pointRadii: 6, //大圆点被选中时显示的圆心的半径
                space: 27, //大圆点之间的间隙
                width: 190, //整个组件的宽度
                height: 190, //整个组件的高度
                lineColor: "rgba(255,255,255,1)", //用户划出线条的颜色
                zindex: 100, //整个组件的css z-index属性
              });
            }

            $("#gesturepwd").on("hasPasswd", function (e, passwd) {
              var password = common.sm2.doCrypt(pwdType.cryptKey, passwd);
              console.log(password);
              if ($this.sPwdStatus()) {
                var verifyResult = common.fetch("/auth/mfa/spwd/verify", {
                  method: "POST",
                  query: { authId: $this.authId, sPwd: password },
                }).data;
                if (verifyResult.success) {
                  $("#gesturepwd").trigger("passwdRight");
                  $this.spwd_msg("密码正确");
                  common.redirectTo(verifyResult.redirectUrl);
                } else {
                  $("#gesturepwd").trigger("passwdWrong");
                  $this.spwd_msg("密码错误");
                }
              } else {
                if (initPwd === "") {
                  initPwd = passwd;
                  $this.spwd_msg("设置成功，请再次确认");
                  $("#gesturepwd").trigger("passwdRight");
                } else {
                  if (initPwd === passwd) {
                    $this.spwd_msg("两次密码一样");
                    $("#gesturepwd").trigger("passwdRight");
                    var verifyResult = common.fetch("/auth/mfa/spwd/verify", {
                      method: "POST",
                      query: { authId: $this.authId, sPwd: password },
                    }).data;
                    if (verifyResult.success) {
                      $("#gesturepwd").trigger("passwdRight");
                      $this.spwd_msg("密码设置成功");
                      common.redirectTo(verifyResult.redirectUrl);
                    } else {
                      $("#gesturepwd").trigger("passwdWrong");
                      $this.spwd_msg("密码设置出错");
                    }
                  } else {
                    $this.spwd_msg("两次密码不一样 ");
                    $("#gesturepwd").trigger("passwdWrong");
                  }
                }
              }
            });
          };
          setQR();
          LoadParam();
        }
      },
      template: require("./template/SSO.html"),
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/component/sso/SSO.js
// module id = 168
// module chunks = 0